import { applyMaintenanceMode, getMaintenanceMode, startMaintenanceModeMonitoring } from "./maintenance";
import { reportErrorToNR } from "./util/reportErrorToNR";

function loadApplication(): Promise<unknown> {
  // Vite resolves this dynamic import to the content-hashed application bundle in production.
  return import("./application-entry");
}

export async function bootstrap(): Promise<void> {
  const maintenanceMode = await getMaintenanceMode();

  if (applyMaintenanceMode(maintenanceMode)) return;
  startMaintenanceModeMonitoring();
  if (maintenanceMode.enabled) return;

  await loadApplication();
}

bootstrap().catch(error => {
  const bootstrapError = error instanceof Error ? error : new Error(String(error));
  reportErrorToNR(bootstrapError, { phase: "application bootstrap" }).catch(reportingError => {
    console.error("Unable to report application bootstrap failure", reportingError);
  });
});
